import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M8 22h8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 11v11", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m19 3-7 8-7-8Z", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Martini";
const Martini = memo(themed(Icon));
export {
  Martini
};
//# sourceMappingURL=martini.js.map
